/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import HeadsetIcon from '@mui/icons-material/Headset';
import StarIcon from '@mui/icons-material/Star';
import WifiIcon from '@mui/icons-material/Wifi';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Icon } from '../styled';

interface IContainerExplanationProps {
  description: string;
  title: 'Connection' | 'Speed Test' | 'Hardware' | 'Call Quality';
}

const iconMap = {
  Connection: <WifiIcon />,
  'Speed Test': <DownloadIcon />,
  Hardware: <HeadsetIcon />,
  'Call Quality': <StarIcon />,
};

export const ContainerExplanationBox: any = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  background: theme.palette.background.paper,
  borderRadius: '6px',
  padding: '15px',
  position: 'relative',
  overflow: 'hidden',
  marginBottom: '10px',
  border: '1px solid #e8e8e8',
}));

export const ContainerExplanation = ({
  description,
  title,
}: IContainerExplanationProps) => {
  return (
    <Grid
      item={true}
      md={3}
      sx={{ margin: 0, padding: 1, height: '100%' }}
      xs={12}
    >
      <ContainerExplanationBox>
        <Icon>{iconMap[title]}</Icon>
        <Typography variant="h6">{title}</Typography>
        <Typography>{description}</Typography>
      </ContainerExplanationBox>
    </Grid>
  );
};
